// 한국도로공사(EXKR) / 도공 테스트(DOGO) 회사 분기 판별 유틸
// EXKR=운영 납품, DOGO=납품 전 테스트. 두 회사는 동일한 도로공사 웹 메뉴 정책을 따른다.
import { getTokenCompanyCode } from '@/utils/clientToken'
import { normalizeCompanyCode } from '@/utils/companyCode'

export const EXKR_COMPANY_CODES = ['EXKR', 'DOGO']

// normalizeCompanyCode 로 스키마 접두(COMPANY_)가 붙은 형태도 코드 형태로 맞춘 뒤 비교한다.
// demoCompany 가 DEMO/COMPANY_DEMO 를 둘 다 인정해 온 것과 같은 관용을 여기에도 적용한 것이다
// (기존에는 이쪽만 코드 형태만 알고 있어 두 판별 유틸의 허용 범위가 비대칭이었다).
const isExkrCompanyCode = (companyCode) => {
  return EXKR_COMPANY_CODES.includes(normalizeCompanyCode(companyCode))
}

// 판별에 사용할 company_code를 우선순위대로 "하나만" 선택한다.
// - 1순위는 client_token(JWT)의 companyCode = 서버가 서명한 값이라 위변조/잔존이 없고,
//   쿠키라서 동기 조회가 가능하다. 라우터 가드(beforeEach)는 하드 리프레시 직후 store가 비어 있는
//   시점에 실행되는데(store 하이드레이션은 headerView/navigationView의 mounted에서 fetchLoginData로
//   이루어져 항상 가드보다 뒤다), 토큰을 직접 읽으므로 F5 콜드스타트에서도 즉시 판별된다.
//   백엔드 EXKR 가드도 같은 클레임으로 회사를 격리하므로 프론트 노출과 서버 403 판정이 일치한다.
// - store 폴백은 토큰 발급 전 흐름(비밀번호 변경 등 setCompanyCode만 된 상태)을 위해 남긴다.
// - localStorage는 쓰지 않는다: 로그아웃/타 회사 로그인 후에도 남는 잔존값이라 오판의 원인이었다.
// - 우선순위 방식인 이유: 이전 OR(.some()) 방식은 소스 하나만 EXKR이어도 EXKR로 판정해서,
//   다른 회사로 로그인한 세션을 EXKR로 오판했다.
const resolveCompanyCode = (store) => {
  const loginBody = store?.getLoginData?.response?.body || store?.loginData?.response?.body || {}
  return (
    getTokenCompanyCode() ||
    store?.getCompanyCode ||
    store?.companyCode ||
    loginBody.company_code ||
    loginBody.companyCode
  )
}

// EXKR/DOGO 판별 단일 진입점. 라우터 가드/사이드바/대시보드 모두 이 함수만 사용한다.
export const isExkrCompanyContext = (store) => isExkrCompanyCode(resolveCompanyCode(store))
